module.exports = "pegasus/assets/blocks/column-1-theme3.png";